import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'faire_direct-pdp_signup_banner_cta-click';
/**
 * Fires on &quot;Sign up for free&quot; cta click in the sign up banner on the fd product detail page.
 */
export function trackFaireDirectPdpSignupBannerCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
